import ContentContainer from "components/ContentContainer";
import { breakpoints, Heading } from "iparque-components";
import styled from "styled-components";
import { getAnimationConfig } from "theme/staggeredAnimations";

interface StyledHeadingProps {
  isSectionVisible: boolean;
}

export const StyledContentContainer = styled(ContentContainer)`
  padding: 100px 0;
`;

export const StyledHeading = styled(Heading)<StyledHeadingProps>`
  line-height: 1.1;
  display: unset;
  margin-bottom: 80px;

  @media (min-width: ${breakpoints.md}) {
    opacity: 0;

    ${({ isSectionVisible }) => (isSectionVisible ? getAnimationConfig() : "")};
  }
`;

export const AdvantagesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 80px;

  @media (max-width: ${breakpoints.lg}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;
